import { c as _c } from "react/compiler-runtime";
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { GrowthbookFlagsEnum } from 'growthbook/types';
import { settingsMenuHref } from 'modules/profile/constants/settings-menu-href';
import { settingsMenuLocoKeys } from 'modules/profile/constants/settings-menu-loco-keys';
import { SettingsMenuEnum } from 'modules/profile/enums/settings-menu-enum';
import { SettingsMenuInterface, SettingsMenuItemsResult } from 'modules/profile/types/settings-interface';
import { getMenuItemDataTestId } from 'modules/profile/utils/get-menu-item-data-test-id';
import { useRouter } from 'next/router';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { usePermission } from 'shared/hooks/use-permission';
export const useSettingsMenuItems = () => {
  const $ = _c(161);
  const {
    t
  } = useLocoTranslation();
  const {
    pathname
  } = useRouter();
  const {
    isReady,
    pagePermissions
  } = usePermission();
  const mcpKeysIsOn = useFeatureIsOn(GrowthbookFlagsEnum.McpKeys);
  let t0;
  if ($[0] !== pathname) {
    t0 = url => pathname.includes(url);
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const regularIsActiveCheck = t0;
  let t1;
  if ($[2] !== pagePermissions) {
    t1 = menuItem => Boolean(pagePermissions[settingsMenuHref[menuItem]]);
    $[2] = pagePermissions;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const hasPermission = t1;
  let t2;
  if ($[4] !== t) {
    t2 = t(settingsMenuLocoKeys[SettingsMenuEnum.profile]);
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = hasPermission(SettingsMenuEnum.profile);
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = getMenuItemDataTestId(SettingsMenuEnum.profile);
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== regularIsActiveCheck || $[8] !== t2 || $[9] !== t3) {
    t5 = {
      name: t2,
      href: settingsMenuHref[SettingsMenuEnum.profile],
      shouldRender: t3,
      dataTestId: t4,
      isActive: regularIsActiveCheck
    };
    $[7] = regularIsActiveCheck;
    $[8] = t2;
    $[9] = t3;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t(settingsMenuLocoKeys[SettingsMenuEnum.account]);
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const t7 = hasPermission(SettingsMenuEnum.account);
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = getMenuItemDataTestId(SettingsMenuEnum.account);
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== regularIsActiveCheck || $[15] !== t6 || $[16] !== t7) {
    t9 = {
      name: t6,
      href: settingsMenuHref[SettingsMenuEnum.account],
      shouldRender: t7,
      dataTestId: t8,
      isActive: regularIsActiveCheck
    };
    $[14] = regularIsActiveCheck;
    $[15] = t6;
    $[16] = t7;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t) {
    t10 = t(settingsMenuLocoKeys[SettingsMenuEnum.my_plan]);
    $[18] = t;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  const t11 = hasPermission(SettingsMenuEnum.my_plan);
  let t12;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = getMenuItemDataTestId(SettingsMenuEnum.my_plan);
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== regularIsActiveCheck || $[22] !== t10 || $[23] !== t11) {
    t13 = {
      name: t10,
      href: settingsMenuHref[SettingsMenuEnum.my_plan],
      shouldRender: t11,
      dataTestId: t12,
      isActive: regularIsActiveCheck
    };
    $[21] = regularIsActiveCheck;
    $[22] = t10;
    $[23] = t11;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t) {
    t14 = t(settingsMenuLocoKeys[SettingsMenuEnum.payment_gateways]);
    $[25] = t;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  const t15 = hasPermission(SettingsMenuEnum.payment_gateways);
  let t16;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = getMenuItemDataTestId(SettingsMenuEnum.payment_gateways);
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== regularIsActiveCheck || $[29] !== t14 || $[30] !== t15) {
    t17 = {
      name: t14,
      href: settingsMenuHref[SettingsMenuEnum.payment_gateways],
      shouldRender: t15,
      dataTestId: t16,
      isActive: regularIsActiveCheck
    };
    $[28] = regularIsActiveCheck;
    $[29] = t14;
    $[30] = t15;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== t) {
    t18 = t(settingsMenuLocoKeys[SettingsMenuEnum.manage_subscriptions]);
    $[32] = t;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  const t19 = hasPermission(SettingsMenuEnum.manage_subscriptions);
  let t20;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = getMenuItemDataTestId(SettingsMenuEnum.manage_subscriptions);
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== regularIsActiveCheck || $[36] !== t18 || $[37] !== t19) {
    t21 = {
      name: t18,
      href: settingsMenuHref[SettingsMenuEnum.manage_subscriptions],
      shouldRender: t19,
      dataTestId: t20,
      isActive: regularIsActiveCheck
    };
    $[35] = regularIsActiveCheck;
    $[36] = t18;
    $[37] = t19;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] !== t) {
    t22 = t(settingsMenuLocoKeys[SettingsMenuEnum.mailing]);
    $[39] = t;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  const t23 = hasPermission(SettingsMenuEnum.mailing);
  let t24;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = getMenuItemDataTestId(SettingsMenuEnum.mailing);
    $[41] = t24;
  } else {
    t24 = $[41];
  }
  let t25;
  if ($[42] !== regularIsActiveCheck || $[43] !== t22 || $[44] !== t23) {
    t25 = {
      name: t22,
      href: settingsMenuHref[SettingsMenuEnum.mailing],
      shouldRender: t23,
      dataTestId: t24,
      isActive: regularIsActiveCheck
    };
    $[42] = regularIsActiveCheck;
    $[43] = t22;
    $[44] = t23;
    $[45] = t25;
  } else {
    t25 = $[45];
  }
  let t26;
  if ($[46] !== t) {
    t26 = t(settingsMenuLocoKeys[SettingsMenuEnum.membership]);
    $[46] = t;
    $[47] = t26;
  } else {
    t26 = $[47];
  }
  const t27 = hasPermission(SettingsMenuEnum.membership);
  let t28;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = getMenuItemDataTestId(SettingsMenuEnum.membership);
    $[48] = t28;
  } else {
    t28 = $[48];
  }
  let t29;
  if ($[49] !== regularIsActiveCheck || $[50] !== t26 || $[51] !== t27) {
    t29 = {
      name: t26,
      href: settingsMenuHref[SettingsMenuEnum.membership],
      shouldRender: t27,
      dataTestId: t28,
      isActive: regularIsActiveCheck
    };
    $[49] = regularIsActiveCheck;
    $[50] = t26;
    $[51] = t27;
    $[52] = t29;
  } else {
    t29 = $[52];
  }
  let t30;
  if ($[53] !== t) {
    t30 = t(settingsMenuLocoKeys[SettingsMenuEnum.payment_page]);
    $[53] = t;
    $[54] = t30;
  } else {
    t30 = $[54];
  }
  const t31 = hasPermission(SettingsMenuEnum.payment_page);
  let t32;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = getMenuItemDataTestId(SettingsMenuEnum.payment_page);
    $[55] = t32;
  } else {
    t32 = $[55];
  }
  let t33;
  if ($[56] !== regularIsActiveCheck || $[57] !== t30 || $[58] !== t31) {
    t33 = {
      name: t30,
      href: settingsMenuHref[SettingsMenuEnum.payment_page],
      shouldRender: t31,
      dataTestId: t32,
      isActive: regularIsActiveCheck
    };
    $[56] = regularIsActiveCheck;
    $[57] = t30;
    $[58] = t31;
    $[59] = t33;
  } else {
    t33 = $[59];
  }
  let t34;
  if ($[60] !== t) {
    t34 = t(settingsMenuLocoKeys[SettingsMenuEnum.sales_funnel]);
    $[60] = t;
    $[61] = t34;
  } else {
    t34 = $[61];
  }
  const t35 = hasPermission(SettingsMenuEnum.sales_funnel);
  let t36;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = getMenuItemDataTestId(SettingsMenuEnum.sales_funnel);
    $[62] = t36;
  } else {
    t36 = $[62];
  }
  let t37;
  if ($[63] !== regularIsActiveCheck || $[64] !== t34 || $[65] !== t35) {
    t37 = {
      name: t34,
      href: settingsMenuHref[SettingsMenuEnum.sales_funnel],
      shouldRender: t35,
      dataTestId: t36,
      isActive: regularIsActiveCheck
    };
    $[63] = regularIsActiveCheck;
    $[64] = t34;
    $[65] = t35;
    $[66] = t37;
  } else {
    t37 = $[66];
  }
  let t38;
  if ($[67] !== t) {
    t38 = t(settingsMenuLocoKeys[SettingsMenuEnum.shipping]);
    $[67] = t;
    $[68] = t38;
  } else {
    t38 = $[68];
  }
  const t39 = hasPermission(SettingsMenuEnum.shipping);
  let t40;
  if ($[69] === Symbol.for("react.memo_cache_sentinel")) {
    t40 = getMenuItemDataTestId(SettingsMenuEnum.shipping);
    $[69] = t40;
  } else {
    t40 = $[69];
  }
  let t41;
  if ($[70] !== regularIsActiveCheck || $[71] !== t38 || $[72] !== t39) {
    t41 = {
      name: t38,
      href: settingsMenuHref[SettingsMenuEnum.shipping],
      shouldRender: t39,
      dataTestId: t40,
      isActive: regularIsActiveCheck
    };
    $[70] = regularIsActiveCheck;
    $[71] = t38;
    $[72] = t39;
    $[73] = t41;
  } else {
    t41 = $[73];
  }
  let t42;
  if ($[74] !== t) {
    t42 = t(settingsMenuLocoKeys[SettingsMenuEnum.affiliate_program]);
    $[74] = t;
    $[75] = t42;
  } else {
    t42 = $[75];
  }
  const t43 = hasPermission(SettingsMenuEnum.affiliate_program);
  let t44;
  if ($[76] === Symbol.for("react.memo_cache_sentinel")) {
    t44 = getMenuItemDataTestId(SettingsMenuEnum.affiliate_program);
    $[76] = t44;
  } else {
    t44 = $[76];
  }
  let t45;
  if ($[77] !== regularIsActiveCheck || $[78] !== t42 || $[79] !== t43) {
    t45 = {
      name: t42,
      href: settingsMenuHref[SettingsMenuEnum.affiliate_program],
      shouldRender: t43,
      dataTestId: t44,
      isActive: regularIsActiveCheck
    };
    $[77] = regularIsActiveCheck;
    $[78] = t42;
    $[79] = t43;
    $[80] = t45;
  } else {
    t45 = $[80];
  }
  let t46;
  if ($[81] !== t) {
    t46 = t(settingsMenuLocoKeys[SettingsMenuEnum.custom_domains]);
    $[81] = t;
    $[82] = t46;
  } else {
    t46 = $[82];
  }
  const t47 = hasPermission(SettingsMenuEnum.custom_domains);
  let t48;
  if ($[83] === Symbol.for("react.memo_cache_sentinel")) {
    t48 = getMenuItemDataTestId(SettingsMenuEnum.custom_domains);
    $[83] = t48;
  } else {
    t48 = $[83];
  }
  let t49;
  if ($[84] !== regularIsActiveCheck || $[85] !== t46 || $[86] !== t47) {
    t49 = {
      name: t46,
      href: settingsMenuHref[SettingsMenuEnum.custom_domains],
      shouldRender: t47,
      dataTestId: t48,
      isActive: regularIsActiveCheck
    };
    $[84] = regularIsActiveCheck;
    $[85] = t46;
    $[86] = t47;
    $[87] = t49;
  } else {
    t49 = $[87];
  }
  let t50;
  if ($[88] !== mcpKeysIsOn || $[89] !== t) {
    t50 = mcpKeysIsOn ? t(settingsMenuLocoKeys[SettingsMenuEnum.public_api]) : t("dashboard.user_settings.public_api.title_plural");
    $[88] = mcpKeysIsOn;
    $[89] = t;
    $[90] = t50;
  } else {
    t50 = $[90];
  }
  const t51 = hasPermission(SettingsMenuEnum.public_api);
  let t52;
  if ($[91] === Symbol.for("react.memo_cache_sentinel")) {
    t52 = getMenuItemDataTestId(SettingsMenuEnum.public_api);
    $[91] = t52;
  } else {
    t52 = $[91];
  }
  let t53;
  if ($[92] !== regularIsActiveCheck || $[93] !== t50 || $[94] !== t51) {
    t53 = {
      name: t50,
      href: settingsMenuHref[SettingsMenuEnum.public_api],
      shouldRender: t51,
      dataTestId: t52,
      isActive: regularIsActiveCheck
    };
    $[92] = regularIsActiveCheck;
    $[93] = t50;
    $[94] = t51;
    $[95] = t53;
  } else {
    t53 = $[95];
  }
  let t54;
  if ($[96] !== t) {
    t54 = t(settingsMenuLocoKeys[SettingsMenuEnum.webhooks]);
    $[96] = t;
    $[97] = t54;
  } else {
    t54 = $[97];
  }
  const t55 = hasPermission(SettingsMenuEnum.webhooks);
  let t56;
  if ($[98] === Symbol.for("react.memo_cache_sentinel")) {
    t56 = getMenuItemDataTestId(SettingsMenuEnum.webhooks);
    $[98] = t56;
  } else {
    t56 = $[98];
  }
  let t57;
  if ($[99] !== regularIsActiveCheck || $[100] !== t54 || $[101] !== t55) {
    t57 = {
      name: t54,
      href: settingsMenuHref[SettingsMenuEnum.webhooks],
      shouldRender: t55,
      dataTestId: t56,
      isActive: regularIsActiveCheck
    };
    $[99] = regularIsActiveCheck;
    $[100] = t54;
    $[101] = t55;
    $[102] = t57;
  } else {
    t57 = $[102];
  }
  let t58;
  if ($[103] !== t) {
    t58 = t(settingsMenuLocoKeys[SettingsMenuEnum.integrations]);
    $[103] = t;
    $[104] = t58;
  } else {
    t58 = $[104];
  }
  const t59 = hasPermission(SettingsMenuEnum.integrations);
  let t60;
  if ($[105] === Symbol.for("react.memo_cache_sentinel")) {
    t60 = getMenuItemDataTestId(SettingsMenuEnum.integrations);
    $[105] = t60;
  } else {
    t60 = $[105];
  }
  let t61;
  if ($[106] !== regularIsActiveCheck || $[107] !== t58 || $[108] !== t59) {
    t61 = {
      name: t58,
      href: settingsMenuHref[SettingsMenuEnum.integrations],
      shouldRender: t59,
      dataTestId: t60,
      isActive: regularIsActiveCheck
    };
    $[106] = regularIsActiveCheck;
    $[107] = t58;
    $[108] = t59;
    $[109] = t61;
  } else {
    t61 = $[109];
  }
  let t62;
  if ($[110] !== t) {
    t62 = t(settingsMenuLocoKeys[SettingsMenuEnum.affiliate_commissions]);
    $[110] = t;
    $[111] = t62;
  } else {
    t62 = $[111];
  }
  const t63 = hasPermission(SettingsMenuEnum.affiliate_commissions);
  let t64;
  if ($[112] === Symbol.for("react.memo_cache_sentinel")) {
    t64 = getMenuItemDataTestId(SettingsMenuEnum.affiliate_commissions);
    $[112] = t64;
  } else {
    t64 = $[112];
  }
  let t65;
  if ($[113] !== regularIsActiveCheck || $[114] !== t62 || $[115] !== t63) {
    t65 = {
      name: t62,
      href: settingsMenuHref[SettingsMenuEnum.affiliate_commissions],
      shouldRender: t63,
      dataTestId: t64,
      isActive: regularIsActiveCheck
    };
    $[113] = regularIsActiveCheck;
    $[114] = t62;
    $[115] = t63;
    $[116] = t65;
  } else {
    t65 = $[116];
  }
  let t66;
  if ($[117] !== t) {
    t66 = t(settingsMenuLocoKeys[SettingsMenuEnum.notification]);
    $[117] = t;
    $[118] = t66;
  } else {
    t66 = $[118];
  }
  const t67 = hasPermission(SettingsMenuEnum.notification);
  let t68;
  if ($[119] === Symbol.for("react.memo_cache_sentinel")) {
    t68 = getMenuItemDataTestId(SettingsMenuEnum.notification);
    $[119] = t68;
  } else {
    t68 = $[119];
  }
  let t69;
  if ($[120] !== regularIsActiveCheck || $[121] !== t66 || $[122] !== t67) {
    t69 = {
      name: t66,
      href: settingsMenuHref[SettingsMenuEnum.notification],
      shouldRender: t67,
      dataTestId: t68,
      isActive: regularIsActiveCheck
    };
    $[120] = regularIsActiveCheck;
    $[121] = t66;
    $[122] = t67;
    $[123] = t69;
  } else {
    t69 = $[123];
  }
  let t70;
  if ($[124] !== t) {
    t70 = t(settingsMenuLocoKeys[SettingsMenuEnum.workspace_members]);
    $[124] = t;
    $[125] = t70;
  } else {
    t70 = $[125];
  }
  const t71 = hasPermission(SettingsMenuEnum.workspace_members);
  let t72;
  if ($[126] === Symbol.for("react.memo_cache_sentinel")) {
    t72 = getMenuItemDataTestId(SettingsMenuEnum.workspace_members);
    $[126] = t72;
  } else {
    t72 = $[126];
  }
  let t73;
  if ($[127] !== regularIsActiveCheck || $[128] !== t70 || $[129] !== t71) {
    t73 = {
      name: t70,
      href: settingsMenuHref[SettingsMenuEnum.workspace_members],
      shouldRender: t71,
      dataTestId: t72,
      isActive: regularIsActiveCheck
    };
    $[127] = regularIsActiveCheck;
    $[128] = t70;
    $[129] = t71;
    $[130] = t73;
  } else {
    t73 = $[130];
  }
  let t74;
  if ($[131] !== t) {
    t74 = t(settingsMenuLocoKeys[SettingsMenuEnum.change_password]);
    $[131] = t;
    $[132] = t74;
  } else {
    t74 = $[132];
  }
  const t75 = hasPermission(SettingsMenuEnum.change_password);
  let t76;
  if ($[133] === Symbol.for("react.memo_cache_sentinel")) {
    t76 = getMenuItemDataTestId(SettingsMenuEnum.change_password);
    $[133] = t76;
  } else {
    t76 = $[133];
  }
  let t77;
  if ($[134] !== regularIsActiveCheck || $[135] !== t74 || $[136] !== t75) {
    t77 = {
      name: t74,
      href: settingsMenuHref[SettingsMenuEnum.change_password],
      shouldRender: t75,
      dataTestId: t76,
      isActive: regularIsActiveCheck
    };
    $[134] = regularIsActiveCheck;
    $[135] = t74;
    $[136] = t75;
    $[137] = t77;
  } else {
    t77 = $[137];
  }
  let t78;
  if ($[138] !== t13 || $[139] !== t17 || $[140] !== t21 || $[141] !== t25 || $[142] !== t29 || $[143] !== t33 || $[144] !== t37 || $[145] !== t41 || $[146] !== t45 || $[147] !== t49 || $[148] !== t5 || $[149] !== t53 || $[150] !== t57 || $[151] !== t61 || $[152] !== t65 || $[153] !== t69 || $[154] !== t73 || $[155] !== t77 || $[156] !== t9) {
    t78 = [t5, t9, t13, t17, t21, t25, t29, t33, t37, t41, t45, t49, t53, t57, t61, t65, t69, t73, t77];
    $[138] = t13;
    $[139] = t17;
    $[140] = t21;
    $[141] = t25;
    $[142] = t29;
    $[143] = t33;
    $[144] = t37;
    $[145] = t41;
    $[146] = t45;
    $[147] = t49;
    $[148] = t5;
    $[149] = t53;
    $[150] = t57;
    $[151] = t61;
    $[152] = t65;
    $[153] = t69;
    $[154] = t73;
    $[155] = t77;
    $[156] = t9;
    $[157] = t78;
  } else {
    t78 = $[157];
  }
  const menuItems = t78;
  let t79;
  if ($[158] !== isReady || $[159] !== menuItems) {
    t79 = {
      menuItems,
      isReady
    };
    $[158] = isReady;
    $[159] = menuItems;
    $[160] = t79;
  } else {
    t79 = $[160];
  }
  return t79;
};